import { render } from "./WizardDataset.vue?vue&type=template&id=4127697b"
import script from "./WizardDataset.vue?vue&type=script&lang=js"
export * from "./WizardDataset.vue?vue&type=script&lang=js"

import "./WizardDataset.vue?vue&type=style&index=0&id=4127697b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepper});
